import { MOKA_SERVICE_HOST, API_URL } from 'api/constants';

export const getBusinessId = state => state.moka.user.business.id;
export const getOutletId = state => state.form.search.values.outletIds[0];
export const TABLE_MANAGEMENT_SERVICE_URL = `${MOKA_SERVICE_HOST}/table-management/v1`;
export const ADD_SUBSCRIPTION = `${API_URL}/v1/feature/add_subscription`;
